import { render } from "./OuterListPage.vue?vue&type=template&id=f38684ba&scoped=true&ts=true"
import script from "./OuterListPage.vue?vue&type=script&lang=ts"
export * from "./OuterListPage.vue?vue&type=script&lang=ts"

import "./OuterListPage.vue?vue&type=style&index=0&id=f38684ba&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src186255619/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f38684ba"]])

export default __exports__